import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { hotelInfo } from '../config/hotelTexts';
import logoWhite from '../assets/images/logo-white.png';
import { useLanguage } from '../context/LanguageContext';

// Placeholder image - à remplacer par les vraies photos plus tard
const heroImage = '/images/st-pierre.jpg';

const HeroContainer = styled.div`
  height: 100vh;
  min-height: 600px;
  background-image: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(${heroImage});
  background-size: cover;
  background-position: center;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: ${({ theme }) => theme.colors.white};
  position: relative;
`;

const HeroContent = styled.div`
  max-width: 800px;
  padding: 0 ${({ theme }) => theme.spacing.md};
  z-index: 1;
`;

const HeroTitle = styled.h1`
  font-size: 3.5rem;
  margin-bottom: ${({ theme }) => theme.spacing.md};
  color: ${({ theme }) => theme.colors.white};
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  
  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    font-size: 2.5rem;
  }
`;

const HeroSubtitle = styled.p`
  font-size: 1.5rem;
  margin-bottom: ${({ theme }) => theme.spacing.lg};
  text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.5);
  
  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    font-size: 1.2rem;
  }
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.md};
  justify-content: center;
  
  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    flex-direction: column;
    align-items: center;
  }
`;

const HeroButton = styled(Link)`
  display: inline-block;
  padding: ${({ theme }) => theme.spacing.md} ${({ theme }) => theme.spacing.xl};
  background-color: ${({ theme, primary }) => primary ? theme.colors.primary : 'transparent'};
  color: ${({ theme }) => theme.colors.white};
  border: 2px solid ${({ theme, primary }) => primary ? theme.colors.primary : theme.colors.white};
  border-radius: ${({ theme }) => theme.borderRadius.small};
  font-weight: 600;
  text-decoration: none;
  transition: all ${({ theme }) => theme.transitions.medium};
  min-width: 180px;
  
  &:hover {
    background-color: ${({ theme, primary }) => primary ? theme.colors.secondary : theme.colors.white};
    border-color: ${({ theme, primary }) => primary ? theme.colors.secondary : theme.colors.white};
    color: ${({ theme, primary }) => primary ? theme.colors.white : theme.colors.primary};
    transform: translateY(-3px);
  }
  
  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    width: 100%;
  }
`;

const ScrollDown = styled.div`
  position: absolute;
  bottom: ${({ theme }) => theme.spacing.xl};
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  
  span {
    font-size: 0.9rem;
    margin-bottom: ${({ theme }) => theme.spacing.xs};
  }
  
  svg {
    animation: bounce 2s infinite;
  }
  
  @keyframes bounce {
    0%, 20%, 50%, 80%, 100% {
      transform: translateY(0);
    }
    40% {
      transform: translateY(-10px);
    }
    60% {
      transform: translateY(-5px);
    }
  }
`;

const Hero = () => {
  const { t, language } = useLanguage();
  
  const scrollToContent = () => {
    window.scrollTo({
      top: window.innerHeight,
      behavior: 'smooth'
    });
  };
  
  return (
    <HeroContainer>
      <HeroContent>
        <HeroTitle>
          <img src={logoWhite} alt="Logo Saint-Pierre" style={{width: '60px', height: '60px', marginRight: '15px'}} />
          {hotelInfo.name}
        </HeroTitle>
        <HeroSubtitle>{t('home.hero.subtitle')}</HeroSubtitle>
        <ButtonGroup>
          <HeroButton to={`/${language}/chambres`} primary>{t('common.readMore')}</HeroButton>
          <HeroButton to={`/${language}/restaurant`}>{t('common.seeMenu')}</HeroButton>
        </ButtonGroup>
      </HeroContent>
      
      <ScrollDown onClick={scrollToContent}>
        <span>{t('common.discover')}</span>
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 16 16">
          <path fillRule="evenodd" d="M8 1a.5.5 0 0 1 .5.5v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L7.5 13.293V1.5A.5.5 0 0 1 8 1z"/>
        </svg>
      </ScrollDown>
    </HeroContainer>
  );
};

export default Hero;
